import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryHotSearchs(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/hot-search`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryHotSearch(hotSearchId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/hot-search/${hotSearchId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  value
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addHotSearch(
  {
    value,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/hot-search`,
    method: 'post',
    data: {
      value,
    },
  });
}

/**
 * 更新
 * @param hotSearchId
 * @param  value
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateHotSearch(hotSearchId, {
  value,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/hot-search/${hotSearchId}`,
    method: 'patch',
    data: {
      value,
    },
  });
}

/**
 * 删除
 * @param hotSearchId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteHotSearch(hotSearchId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/hot-search/${hotSearchId}`,
    method: 'delete',
  });
}

export default {};
